import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { Button } from "@/components/ui/button";
import { ClipboardPlus } from "lucide-react";

type Props = {
    disabled?: boolean;
    onClick: () => void;
}

export const AddQuestionIconButton = ({
    disabled = false,
    onClick,
  }: Props) => {
    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <Button
                    disabled={disabled}
                    size={'sm'}
                    onClick={onClick}
                >
                    <span>Add Question</span><ClipboardPlus size={16}/>
                </Button>
            </TooltipTrigger>
            <TooltipContent>
                Add Question
            </TooltipContent>
        </Tooltip>
    )
}
